import * as React from 'react';

import { SurveyResultQuestion, SurveyResultsResponse } from '../types';
import useLocalStorage from './useLocalStorage';

const QUESTION_RESULTS_LOCALSTORAGE_KEY = 'question-results';

const useQuestionResults = (
  currentQuestionUid: string,
  lastResult: SurveyResultsResponse | null
) => {
  const [questions, setQuestions] = useLocalStorage<
    Record<string, SurveyResultQuestion>
  >(QUESTION_RESULTS_LOCALSTORAGE_KEY);

  const nonNullQuestions = questions || {};

  React.useEffect(() => {
    if (!lastResult) {
      return;
    }

    const q = lastResult.surveyResults.questions.find(
      (cur) => cur.uid === currentQuestionUid
    );

    if (q && !{}.hasOwnProperty.call(nonNullQuestions, q.uid)) {
      setQuestions({
        ...nonNullQuestions,
        [q.uid]: q
      });
    }
  }, [nonNullQuestions, lastResult, setQuestions]);

  return nonNullQuestions;
};

export default useQuestionResults;
